import * as React from "react";
import { useFetchCLForActiveVariant } from "../../../../../../../../../hooks/modules/EcommContent/ContactLensesEcommContent/components/CLPrescriptionSelector/hooks/use-fetch-cl-for-active-variant.js";
import { CLPrescriptionColumn } from "./CLPrescriptionColumn.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const CLPrescriptionColumnContainer = (props) => {
  const { eyeSideId } = props;
  const { actions, state } = useCLEcommContext();
  const { columnCheckboxes } = state.configurator;
  const { isEnabled } = state.configurator[eyeSideId];
  useFetchCLForActiveVariant({ eyeSide: eyeSideId });
  const handleAttributeChange = React.useCallback(
    (attribute, value, eyeSide) => actions.updatePrescriptionAttribute(eyeSide, attribute, value),
    [actions]
  );
  const handleCheckboxChange = React.useCallback(
    (isEnabled2, eyeSide) => actions.updateColumnCheckbox(eyeSide, isEnabled2),
    [actions]
  );
  return /* @__PURE__ */ React.createElement(
    CLPrescriptionColumn,
    {
      ...props,
      isEnabled,
      showCheckboxError: columnCheckboxes.showError,
      onAttributeChange: handleAttributeChange,
      onCheckboxChange: handleCheckboxChange
    }
  );
};
export {
  CLPrescriptionColumnContainer
};
//# sourceMappingURL=CLPrescriptionColumnContainer.js.map
